import clsx from 'clsx';
import React, { useState } from 'react';

import messageIcon from 'images/directory/message_icon.svg';

import { CommentUser } from '../../../utils/backend-api/comments';
import { Button } from '../../BaseUI';
import MessageModal from '../MessageModal';
import styles from './styles.module.scss';

interface MessageUserButtonProps {
  className?: string;
  user: CommentUser;
  variant?: 'link';
}

function MessageUserButton({ className, user, variant }: MessageUserButtonProps) {
  const [messageUser, setMessageUser] = useState(false);
  const variantClassName = variant || 'default';

  return (
    <>
      <Button
        className={clsx(styles.MessageUserButton, styles[`${variantClassName}Button`], className)}
        onClick={() => setMessageUser(true)}
        data-test="message-button"
        variant={variant}
      >
        {!variant && <img className={styles.messageIcon} src={messageIcon} />}
        <span>Message</span>
      </Button>
      {messageUser && <MessageModal user={user} onClose={() => setMessageUser(false)} />}
    </>
  );
}

export default MessageUserButton;
